import * as yup from 'yup';
import { FeatureFlags } from '@centric-os/types';
import { useI18n } from 'vue-i18n';
import { useSplitIoStore } from '@centric-os/stores/splitio/use-split-io';
import { INTEGRATION_DEFINITIONS, INTEGRATION_KEYS } from '../../../constants/integrations';

export default () => {
  const { t } = useI18n();
  const { isFeatureOn } = useSplitIoStore();

  // Validates the devices under each integration's `device_mapping` key (Agilysys, Nextep, Volante)
  const deviceMappingKeys = INTEGRATION_KEYS.map(
    (key) => INTEGRATION_DEFINITIONS[key].deviceMappingKey,
  ).filter(Boolean);

  const deviceMappingSchema = deviceMappingKeys.reduce<Record<string, yup.AnySchema>>(
    (acc, device) => {
      acc[device] = yup.array().of(
        yup.object({
          business_units: yup.array().required(t('errorMessages.required')),
          site_device_id: yup.string().required(t('errorMessages.required')),
          vendor: yup.string().optional(),
          device_type: yup.string().required(t('errorMessages.required')),
        }),
      );
      return acc;
    },
    {},
  );

  const schema = yup
    .object({
      meta: yup.object({
        software_integrations: yup.object({
          nextep: yup
            .object({
              mobile_app: yup.boolean(),
              web: yup.boolean(),
              ...(isFeatureOn(FeatureFlags.NEXTEP_ORDER_STREAMING) && {
                order_streaming_enabled: yup.boolean(),
              }),
            })
            .optional(),
          agilysys: yup
            .object({
              order_streaming_enabled: yup.boolean(),
            })
            .optional(),
          time2eat: yup
            .object({
              enabled: yup.boolean(),
            })
            .optional(),
        }),
      }),
      device_mapping: yup
        .object({
          ...deviceMappingSchema,
        })
        .optional(),
      is: yup
        .object({
          show_in_pos: yup.boolean().optional(),
          show_in_kiosk: yup.boolean().optional(),
        })
        .optional(),
    })
    .test('agilysys-certificate-required', t('errorMessages.required'), function (value) {
      const agilysysConfig = value?.meta?.software_integrations?.agilysys;

      // If order streaming is enabled, we need to check if certificate ID is provided
      if (agilysysConfig?.order_streaming_enabled) {
        // This validation will be handled by the component since the certificate ID
        // is stored in private config, not in the main form data
        // The component will prevent form submission if validation fails
        return true;
      }

      return true;
    });

  return {
    schema,
  };
};
